import PageWrapper from "./src/components/PageWrapper"

export const wrapPageElement = PageWrapper

let finishViewTransition = null

const prefersReducedMotion = () =>
  typeof window !== "undefined" &&
  window.matchMedia("(prefers-reduced-motion: reduce)").matches

// Same-document View Transition: snapshot the current page before Gatsby swaps
// the route, then finish it in onRouteUpdate once the new page has rendered.
// SPA navigations never trigger cross-document transitions, so the transition
// is driven imperatively here.
export const onPreRouteUpdate = () => {
  if (typeof document === "undefined" || !document.startViewTransition) return
  if (prefersReducedMotion()) return

  document.startViewTransition(
    () =>
      new Promise((resolve) => {
        finishViewTransition = resolve
        // Safety net: never let a transition hang if onRouteUpdate is missed.
        setTimeout(() => {
          if (finishViewTransition) {
            finishViewTransition()
            finishViewTransition = null
          }
        }, 400)
      })
  )
}

export const onRouteUpdate = () => {
  if (typeof window === "undefined") return

  if (finishViewTransition) {
    // Supported browsers: finish the active View Transition.
    finishViewTransition()
    finishViewTransition = null
  } else if (
    typeof document !== "undefined" &&
    !document.startViewTransition &&
    !prefersReducedMotion()
  ) {
    // No View Transitions support: play a CSS entry animation on the new page.
    const main = document.querySelector(".page-main")
    if (main) {
      main.classList.remove("page-enter")
      // Force a reflow so the animation re-triggers on every navigation.
      void main.offsetWidth
      main.classList.add("page-enter")
    }
  }

  revealOnScrollFallback()
}

// Fallback for browsers without CSS scroll-driven animations (e.g. Firefox):
// reveal `.project-image` / `.reveal-on-scroll` elements with an
// IntersectionObserver. Browsers with native support use the CSS animation.
function revealOnScrollFallback() {
  if (typeof IntersectionObserver === "undefined") return

  const supportsScrollDriven =
    typeof window.CSS !== "undefined" &&
    CSS.supports("(animation-timeline: view()) and (animation-range: entry)")
  if (supportsScrollDriven) return
  if (prefersReducedMotion()) return

  const elements = document.querySelectorAll(
    ".project-image, .reveal-on-scroll"
  )
  if (!elements.length) return

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("in-view")
          observer.unobserve(entry.target)
        }
      })
    },
    { threshold: 0.15 }
  )

  elements.forEach((el) => {
    el.classList.add("js-reveal")
    observer.observe(el)
  })
}
